import Vue from 'vue'
import VueRouter from 'vue-router'
import ExploreFrame from '../views/ExploreFrame.vue'

Vue.use(VueRouter)

  const routes = [
  {
    path: '/',
    name: 'ExploreFrame',
    component: ExploreFrame
  }
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

export default router
